export default __webpack_public_path__ + "static/media/photo-1542345812-d98b5cd6cf98.fc631d3d.jpeg";